import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterReg.styl';


import './BXmakerAuthuserphoneEnterSmsCode';
import './BXmakerAuthuserphoneEnterUserCall';
import './BXmakerAuthuserphoneEnterBotCall';
import './BXmakerAuthuserphoneEnterBotSpeech';
import './BXmakerAuthuserphoneEnterRegForm';
import './BXmakerAuthuserphoneEnterSimPush';


Vue.component('BXmakerAuthuserphoneEnterReg', {
    name: 'BXmakerAuthuserphoneEnterReg',
    data() {
        return {};
    },
    computed: {},
    methods: {

    },

    template: `
            <div class="bxmaker-authuserphone-enter-reg"  >
                
                 <BXmakerAuthuserphoneHeader class="bxmaker-authuserphone-enter-reg__title" >
                    {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REGISTRATION_TITLE}}
                 </BXmakerAuthuserphoneHeader>  
                
                                              
                 <BXmakerAuthuserphoneEnterRegForm 
                    v-show="!$root.isShowConfirm" 
                 />   
                                        
                 <BXmakerAuthuserphoneEnterSmsCode  
                     v-show="$root.isNeedShowConfirmSmsCode"                                    
                 /> 
                    
                 <BXmakerAuthuserphoneEnterUserCall  
                     v-show="$root.isNeedShowConfirmUserCall"   
                 /> 
                    
                 <BXmakerAuthuserphoneEnterBotCall 
                      v-show="$root.isNeedShowConfirmBotCall"                 
                 />  
                 
                 <BXmakerAuthuserphoneEnterBotSpeech 
                      v-show="$root.isNeedShowConfirmBotSpeech"                 
                 />  
                 
                 <BXmakerAuthuserphoneEnterSimPush 
                      v-show="$root.isNeedShowConfirmSimPush"                 
                 />  
                 
                    
                 <div class="bxmaker-authuserphone-enter-reg__change-confirm" v-if="$root.isNeedShowChangeConfirm"  >
                      <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmType" >
                         {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_CHANGE_CONFIRM_TYPE}}   
                      </BXmakerAuthuserphoneLink> 
                 </div>   
                    
                 <div class="bxmaker-authuserphone-enter-reg__toauth" v-if="!$root.isShowConfirm">
                      <BXmakerAuthuserphoneLink @onClick="$root.toAuth" >
                             {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_TO_AUTH}}   
                     </BXmakerAuthuserphoneLink> 
                 </div>   
                
                             
            </div>
        `,
});